// ============================================================================
// File:
// src/modules/ppe/pages/procurement/dashboard/components/kpi/KPIContainer.jsx
// ============================================================================

import React from "react";
import KPICard from "./KPICard";

export default function KPIContainer({ loading, kpis }) {

  if (loading) return <div>Loading KPIs...</div>;
  if (!kpis) return null;

  return (
    <div className="kpi-grid">

<KPICard
  title="Total Indents"
  value={kpis.total_indents}
  gradient="blue"
/>

<KPICard
  title="Approved Indents"
  value={kpis.approved_indents}
  gradient="green"
/>

<KPICard
  title="Purchase Requests"
  value={kpis.total_pr}
  gradient="purple"
/>

<KPICard
  title="RFQs"
  value={kpis.total_rfq}
  gradient="slate"
/>

<KPICard
  title="Open POs"
  value={kpis.open_po}
  gradient="orange"
/>

<KPICard
  title="GRN Posted"
  value={kpis.grn_posted}
  gradient="emerald"
/>

<KPICard
  title="PO Value"
  value={`₹ ${Number(kpis.total_po_value || 0).toLocaleString()}`}
  gradient="indigo"
/>


    </div>
  );
}
